exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-picture{position:relative;border:1px solid #ccc;border-radius:5px;background-color:#fff;overflow:hidden}.profile-picture__image{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.profile-picture__image--more-width{width:100%;height:auto}.profile-picture__image--more-height{width:auto;height:100%}.profile-picture__remove{position:absolute;top:5px;right:8px;z-index:1;display:inline-block;vertical-align:top;padding:0;margin:0;border:none;line-height:1;outline:0;background-color:transparent}.profile-picture__remove--is-disabled{opacity:.65}.profile-picture__remove-icon{font-size:18px;color:#777}.profile-picture__remove-icon:hover{color:#9b9b9b}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/ProfilePicture/style.css
 ** module id = 1444
 ** module chunks = 10 13 18 19 20 59 62
 **/